import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function Sidebar({setState,onSubmit,categories,last_posts,setCat}:any) {
    return ( 
        <div className="col-lg-4">
            {/* <!-- Search Form Start --> */}
            <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <form className="input-group" onSubmit={onSubmit}>
                    <input 
                        type="text" 
                        className="form-control p-3" 
                        placeholder="جستجو" 
                        aria-label="search input" 
                        onChange={(e) => setState((prev: any) => ({ ...prev, search: e.target.value }))}
                    />
                    <button  type="submit" className="btn btn-danger px-4"><FontAwesomeIcon icon="search"/></button>
                </form>
            </div>
            {/* <!-- Search Form End --> */}

            {/* <!-- Category Start --> */}
            <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                    <h3 className="mb-0">دسته بندی ها</h3>
                </div>
                <div className="link-animated d-flex flex-column justify-content-start">
                   {categories && categories.map((row:any,index:number) => 
                        <button key={index} onClick={() => setCat(row.id)} className="btn h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2 text-start">
                            <FontAwesomeIcon icon="arrow-left" className="me-2"/>{row.name}
                        </button>
                    )}
                </div>
            </div>
            {/* <!-- Category End --> */}

            {/* <!-- Recent Post Start --> */}
            <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                    <h3 className="mb-0">آخرین پست ها</h3>
                </div>
                {last_posts && last_posts.map((row:any,index:number) => 
                <div key={index} className="d-flex rounded overflow-hidden mb-3 ">
                    <img className="img-fluid" src={row.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={row.title}/>
                    <Link to={`/post/${row.id}/${row.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="h5 fw-semi-bold d-flex align-items-center bg-light px-3 mb-0" style={{minWidth:"80%"}}>{row.title}</Link>
                </div>)}
            </div>
            {/* <!-- Recent Post End --> */}

        </div>
     );
}

export default Sidebar;